import React from "react";
import { Chip } from "@mui/material";

const AddonStatusChip = ({ active, label }) => (
  <Chip
    size="small"
    label={label || (active ? "Active" : "Inactive")}
    sx={{
      height: 22,
      fontSize: "0.75rem",
      fontWeight: 600,
      borderRadius: "999px",
      ...(active
        ? {
            backgroundColor: "#ecfdf5",
            color: "#047857",
            border: "1px solid #a7f3d0",
          }
        : {
            backgroundColor: "#fff4eb",
            color: "#F98125",
            border: "1px solid #F98125",
          }),
    }}
  />
);

export default AddonStatusChip;
